import React from 'react';

const TimelineView = ({ tasks, language }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-green-500';
      case 'in_progress':
        return 'bg-blue-500';
      case 'pending':
        return 'bg-gray-300';
      default:
        return 'bg-gray-300';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return '✓';
      case 'in_progress':
        return '⟳';
      case 'pending':
        return '○';
      default:
        return '○';
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString(language === 'tr' ? 'tr-TR' : 'en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  if (!tasks || tasks.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow-md p-6 text-center text-gray-500">
        {language === 'tr' ? 'Henüz görev yok' : 'No tasks yet'}
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-6">
        {language === 'tr' ? '📅 Görev Zaman Çizelgesi' : '📅 Task Timeline'}
      </h3>
      
      <div className="relative">
        {/* Timeline Line */}
        <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-gray-200"></div>
        
        {/* Timeline Items */}
        <div className="space-y-6">
          {tasks.slice(0, 10).map((task, index) => (
            <div key={index} className="relative pl-16">
              {/* Timeline Dot */}
              <div className={`absolute left-0 w-12 h-12 ${getStatusColor(task.status)} rounded-full flex items-center justify-center text-white font-bold shadow-lg`}>
                {getStatusIcon(task.status)}
              </div>
              
              {/* Task Card */}
              <div className="bg-gray-50 rounded-lg p-4 hover:shadow-md transition-shadow">
                <div className="flex justify-between items-start mb-2">
                  <h4 className="font-semibold text-gray-800">{task.topic || task.title}</h4>
                  <span className="text-xs text-gray-500">{formatDate(task.assigned_at || task.created_at)}</span>
                </div>
                
                <div className="flex items-center gap-4 text-sm">
                  <span className="text-gray-600">
                    {task.type || 'Task'}
                  </span>
                  
                  {task.estimated_minutes && (
                    <span className="text-gray-500">
                      ⏱️ {task.estimated_minutes} {language === 'tr' ? 'dk' : 'min'}
                    </span>
                  )}
                  
                  {task.difficulty && (
                    <span className={`px-2 py-1 rounded text-xs ${
                      task.difficulty === 'hard' 
                        ? 'bg-red-100 text-red-700'
                        : task.difficulty === 'medium'
                        ? 'bg-yellow-100 text-yellow-700'
                        : 'bg-green-100 text-green-700'
                    }`}>
                      {task.difficulty}
                    </span>
                  )}
                </div>
                
                {task.correct_rate !== undefined && task.status === 'completed' && (
                  <div className="mt-3 pt-3 border-t border-gray-200">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-gray-600">
                        {language === 'tr' ? 'Başarı Oranı:' : 'Success Rate:'}
                      </span>
                      <span className={`text-sm font-semibold ${
                        task.correct_rate >= 0.8 
                          ? 'text-green-600'
                          : task.correct_rate >= 0.6
                          ? 'text-yellow-600'
                          : 'text-red-600'
                      }`}>
                        {(task.correct_rate * 100).toFixed(0)}%
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TimelineView;
